import React, { Fragment, FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'

import CloudIcon from '@/atoms/icons/cloud.svg'
import { Box } from '@/atoms/layout'
import { Label } from '@/atoms/typography'
import { Space } from '@/styles'

interface Props {
  acceptedTypes: string
  maxSize: number
  isDragActive: boolean
}

const DefaultMessage: FunctionComponent<Props> = ({ acceptedTypes, maxSize, isDragActive }) => {
  const { t } = useTranslation()

  if (isDragActive) {
    return <Label>{t('upload.drop_file')}</Label>
  }

  return (
    <Fragment>
      <Box mr={Space.S12}>
        <CloudIcon />
      </Box>
      <Box>
        <Label fontWeight={700} mb={Space.S8} width={1}>
          {t('upload.drag_and_drop')}
        </Label>
        <Label width={1}>
          {maxSize
            ? t('file_upload.description.error.file-invalid-type', { acceptedTypes, maxSize })
            : t('file_upload.description.file-invalid-type', { acceptedTypes })}
        </Label>
      </Box>
    </Fragment>
  )
}

export default DefaultMessage
